/** Domain service module: messaging.js */
import { request } from '../http/request'
import { API_BASE_URL } from './config'

class BotConversaService {
  sendMessage(data) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/botConversa/sendMessage`, 'post', data)
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

export const botConversa = new BotConversaService()
export default botConversa
